// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-height {
  min-height: calc(100vh - 125px);
}

.login-btn {
  background-color: #43B02A !important;
  border-color: #43B02A;
  color: white !important;
}

.login-text {
  color: white;
  white-space: nowrap;
}

.login-bg {
  background-color: #43B02A !important;
}

.icon-auth {
  position: absolute;
  right: 10px;
  color: #43B02A;
}

.password-icon-register {
  top: 45px;
}

.password-icon-login {
  top: 12px;
}

.invalid-field-label {
  font-size: 80%;
  margin-top: 5px;
  color: #dc3545;
}`, "",{"version":3,"sources":["webpack://./src/scss/ikrb/login.scss","webpack://./src/scss/ikrb/_variables.scss"],"names":[],"mappings":"AAGA;EACI,+BAAA;AAFJ;;AAKA;EAEI,oCAAA;EACA,qBCTO;EDUP,uBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,oCAAA;AAHJ;;AAMA;EACI,kBAAA;EACA,WAAA;EACA,cCzBO;ADsBX;;AAMA;EACI,SAAA;AAHJ;;AAMA;EACI,SAAA;AAHJ;;AAOA;EACI,cAAA;EACA,eAAA;EACA,cAAA;AAJJ","sourcesContent":["\n@import './variables';\n\n.login-height {\n    min-height: calc(100vh - 125px);\n}\n\n.login-btn {\n\n    background-color: $primary !important;\n    border-color: $primary;\n    color: white !important;\n}\n\n.login-text {\n    color: white;\n    white-space: nowrap;\n}\n\n.login-bg {\n    background-color: $primary !important;\n}\n\n.icon-auth {\n    position: absolute;\n    right: 10px;\n    color: $primary;\n}\n\n.password-icon-register{\n    top: 45px;\n}\n\n.password-icon-login{\n    top:12px;\n\n}\n\n.invalid-field-label{\n    font-size: 80%;\n    margin-top:5px;\n    color: #dc3545;\n}","// Colors\n$primary : #43B02A;\n$secondary:#702082;\n$light-green:#43B02A3B;\n$light-grey:#53565A10;\n$mid-grey:gray;\n$dark-grey:#53565A;\n$red:#E03C31;\n$black:#000000;\n$light-purple:#70208208;\n$light-text:#525252;\n$bg-grey:#F5F5F5;\n$bg-grey2:#F3F3F3;\n\n// Card-Map\n$card-text:#9AA1A9;\n$card-text-2:#9CA3AB;\n$card-bar:#B3B4B6;\n$slider-text:#53565A7E;\n\n// Font\n$font-11:11px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
